import { getPageEnv } from '@src/utils'

const seagullHost = {
  local: 'home-dev.zatech.com',
  dev: 'home-dev.zatech.com',
  sit: 'home-sit.zatech.com',
  uat: 'home-uat.zatech.com',
  prd: 'za.group'
}

const i18nHost = seagullHost[process.env.DEPLOY_ENV || 'local']

const i18nMap = {
  en: 'EN',
  hk: '繁'
}

const i18nTypes = {
  en: 'en_US',
  hk: 'zh_HK',
  key: 'KEY'
}

const headeri18nPathMap = {
  local: {
    headerI18Host: 'https://home-dev.zatech.com'
  },
  dev: {
    headerI18Host: 'https://home-dev.zatech.com'
  },
  sit: {
    headerI18Host: 'https://home-sit.zatech.com'
  },
  uat: {
    headerI18Host: 'https://home-uat.zatech.com'
  },
  prd: {
    headerI18Host: 'https://za.group'
  }
}

// 暂时隐藏， VHIS需求上线打开
// process.env.DEPLOY_ENV !== 'prd' && Object.defineProperty(i18nMap, 'key', {
//   value: 'KEY'
// })

const headerI18Host = headeri18nPathMap[getPageEnv() || 'prd'].headerI18Host

export {
  i18nMap,
  i18nTypes,
  i18nHost,
  headerI18Host
}
